import { render, staticRenderFns } from "./SicilFileView.vue?vue&type=template&id=672cc1dc&scoped=true&"
import script from "./SicilFileView.vue?vue&type=script&lang=js&"
export * from "./SicilFileView.vue?vue&type=script&lang=js&"
import style0 from "./SicilFileView.vue?vue&type=style&index=0&id=672cc1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cc1dc",
  null
  
)

export default component.exports